/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IHospitalProcedure } from 'app/shared/model/hospital-procedure.model';

export interface IProcedureEpisode {
  id?: string;
  name?: string | null;
  description?: string | null;
  order?: number | null;
  durationAfterPrevious?: number | null;
  active?: boolean | null;
  cursor?: number;
  lastUpdated?: number | null;
  microSec?: number;
  timestampEntry?: number;
  procedure?: IHospitalProcedure | null;
}

export const defaultValue: Readonly<IProcedureEpisode> = {
  active: false,
};
